import { createContext, useContext, type ReactNode } from 'react';
import type { ParentLabelResolver } from './aria-labels';

const noop: ParentLabelResolver = () => null;

const ParentLabelContext = createContext<ParentLabelResolver>(noop);

interface ParentLabelProviderProps {
  resolver: ParentLabelResolver;
  children: ReactNode;
}

export function ParentLabelProvider({ resolver, children }: ParentLabelProviderProps) {
  return (
    <ParentLabelContext.Provider value={resolver}>
      {children}
    </ParentLabelContext.Provider>
  );
}

export function useParentLabelResolver(): ParentLabelResolver {
  return useContext(ParentLabelContext);
}
